// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__29ucj","productName":"Table_productName__33ljz"};